import styled from 'styled-components'
import BtnMui from '@mui/base/ButtonUnstyled';


const Button = styled(BtnMui)`
`

export { Button }